import { render, staticRenderFns } from "./DialogueManagement.vue?vue&type=template&id=07b86bdf&scoped=true"
import script from "./DialogueManagement.vue?vue&type=script&lang=js"
export * from "./DialogueManagement.vue?vue&type=script&lang=js"
import style0 from "./DialogueManagement.vue?vue&type=style&index=0&id=07b86bdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b86bdf",
  null
  
)

export default component.exports